// CrmPageUnified.tsx - CRM wrapper for unified router
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Box } from '@mui/joy';
import { NotificationProvider } from '../contexts/NotificationContext';
import { PageHeader } from '../components/common/PageHeader';

// Create a query client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export const CrmPageUnified: React.FC = () => {
  const location = useLocation();

  const intro = location.pathname.startsWith('/crm/contacts')
    ? { title: 'Contacts', description: 'Add a contact or import your list. Open a profile to follow up, record notes, and see the full customer history.' }
    : location.pathname.startsWith('/crm/pipeline') || location.pathname.startsWith('/crm/opportunities')
      ? { title: 'Sales pipeline', description: 'Choose a board, then add an opportunity. Move each card as the sale progresses so your team knows what needs attention.' }
      : { title: 'Sales settings', description: 'Create your sales boards and arrange their stages in the order your team works through them.' };
  const hasOwnHeading = /^\/crm\/(contracts|proposals)(\/|$)/.test(location.pathname);

  const isSalesDesk = location.pathname.startsWith('/crm/sales-desk');
  const isContactDetail = /\/crm\/contacts\/\d+/.test(location.pathname);

  return (
    <QueryClientProvider client={queryClient}>
      <NotificationProvider>
        {isContactDetail ? (
          <Outlet />
        ) : (
          <Box sx={{ p: { xs: 1.5, md: 3 }, width: '100%', mx: 'auto', minWidth: 0 }}>
            {!isSalesDesk && !hasOwnHeading && <PageHeader section="Sales" {...intro} />}
            <Outlet />
          </Box>
        )}
      </NotificationProvider>
    </QueryClientProvider>
  );
};